import React, { useEffect, useRef, useState } from 'react';
import { getAuthData } from '../auth/session.js';
import { IconHistory } from '../../components/icons.jsx';
import './history.css';

const currencies = { metacoin: 'MetaCoin', crystal: 'Кристаллы', gem: 'Рубины', spin: 'Крутки', card: 'Карты' };
const fmt = value => Number(value ?? 0).toLocaleString('ru-RU');

export function VaBankHistory({ onClose }) {
  const [scope, setScope] = useState('all');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [refresh, setRefresh] = useState(0);
  const closeRef = useRef(null);
  useEffect(() => {
    const previous = document.activeElement;
    closeRef.current?.focus();
    const key = event => {
      if (event.key === 'Escape') onClose();
      if (event.key === 'Tab') {
        const buttons = [...closeRef.current.closest('[role="dialog"]').querySelectorAll('button:not(:disabled)')];
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', key);
    return () => { document.removeEventListener('keydown', key); previous?.focus?.(); };
  }, []);
  useEffect(() => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    let active = true;
    setLoading(true); setItems([]); setError('');
    (async () => {
      try {
        const initData = getAuthData();
        if (!initData) throw new Error('Откройте игру через Telegram');
        const response = await fetch('/api/vabank/history', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ initData, scope }), signal: controller.signal });
        if (!response.ok) throw new Error('Не удалось загрузить историю. Попробуйте ещё раз');
        const result = await response.json();
        if (!Array.isArray(result.items)) throw new Error('Не удалось загрузить историю');
        if (active) setItems(result.items);
      } catch (failure) { if (active) setError(failure.name === 'AbortError' ? 'Время ожидания истекло. Попробуйте ещё раз' : failure.message); }
      finally { clearTimeout(timeout); if (active) setLoading(false); }
    })();
    return () => { active = false; clearTimeout(timeout); controller.abort(); };
  }, [scope, refresh]);
  return <div className="vabank-history-backdrop"><section className="vabank-history-dialog" role="dialog" aria-modal="true" aria-labelledby="vabank-history-title">
    <header><span><IconHistory /><h2 id="vabank-history-title">История игр</h2></span><button ref={closeRef} onClick={onClose} aria-label="Закрыть историю">×</button></header>
    <div className="vabank-history-tabs" role="group" aria-label="История игр"><button aria-pressed={scope === 'all'} onClick={() => setScope('all')}>Все игры</button><button aria-pressed={scope === 'mine'} onClick={() => setScope('mine')}>Мои игры</button></div>
    <div className="vabank-history-heading"><small>Последние 30 завершённых игр</small><button disabled={loading} onClick={() => setRefresh(value => value + 1)}>Обновить</button></div>
    <div className="vabank-history-list" aria-busy={loading}>
      {loading && <p role="status">Загружаем игры…</p>}
      {error && <p role="alert">{error}</p>}
      {!loading && !error && !items.length && <p>{scope === 'mine' ? 'Вы ещё не участвовали в завершённых играх.' : 'Завершённых игр пока нет.'}</p>}
      {items.map(item => <article key={item.id} className={`vabank-history-card ${item.isMe ? 'is-own' : ''}`}>
        <div className="vabank-history-meta"><b>Игра #{item.id}</b>{item.finishedAt && <time dateTime={item.finishedAt}>{new Date(item.finishedAt).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })} МСК</time>}</div>
        <div className="vabank-history-winner"><span className="vabank-winner-avatar">{Array.from(item.winnerName || 'И')[0]}</span><span><small>ПОБЕДИТЕЛЬ</small><b>{item.winnerName}</b></span>{item.isMe && <em>{item.isWinner ? 'Ваша победа' : 'Вы участвовали'}</em>}</div>
        <dl><div><dt>Банк · {currencies[item.currency]}</dt><dd>{fmt(item.bank)}</dd></div><div><dt>Игроков</dt><dd>{fmt(item.players)}</dd></div><div><dt>{item.currency === 'card' ? 'Выиграно карт' : 'Выплата'}</dt><dd className="vabank-history-prize">{fmt(item.currency === 'card' ? item.bank : item.payout)}</dd></div></dl>
        {item.isMe && <footer>Ваша ставка: <b>{item.myCard || `${fmt(item.myStake)} ${currencies[item.currency] || ''}`}</b></footer>}
      </article>)}
    </div>
  </section></div>;
}
